import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import { toast } from "react-toastify";
import { LOGIN_ADMIN } from "../../services/ApiCalls";
import { useState } from "react";

// const [loader , setLoader] = useState(null);
function* loginUserSaga({ payload, callBack }) {
  try {
    const response = yield call(LOGIN_ADMIN, payload);
    if (response.data.status == "success") {
      toast.success(response?.data?.message);
      localStorage.setItem("token", response?.data?.token || "");
      localStorage.setItem("_id", response?.data?.data?._id);
      localStorage.setItem("profileImage", response?.data?.data?.profileImage);
      localStorage.setItem("name", response?.data?.data?.name);
      localStorage.setItem("email", response?.data?.data?.email);
      localStorage.setItem("role", response?.data?.data?.role);
      // if (
      //   response.data.data.permissions &&
      //   response.data.data.permissions?.length > 0
      // ) {
      //   localStorage.setItem(
      //     "permissions",
      //     JSON.stringify(response.data.data.permissions)
      //   );
      // } else {
      //   localStorage.setItem("permissions", JSON.stringify([]));
      // }
      // localStorage.setItem("countryCode", response?.data?.country_code);
      // localStorage.setItem("mobileNumber", response?.data?.full_phone_number);
      callBack && callBack();
      yield put(ACTION.loginAdmin_Success(response?.data));
    } else {
      // setLoader(false);
      toast.error(response?.data?.message);
      yield put(ACTION.loginAdmin_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.loginAdmin_Fail(error));
  }
}

function* LoginSaga() {
  yield takeEvery(CONST.LOGIN_ADMIN, loginUserSaga);
}

export default LoginSaga;
